import * as React from 'react'

import { Fields } from 'embed/constants/fields'
import { Product } from 'even-ts-static'

import { ApplicationField } from 'embed/components/ApplicationField/container'

import { StepTitle } from 'embed/components/Application/StepTitle'
import { ApplicationStep } from 'embed/constants'
import { StepbystepCreditApplicationWrapper } from '../Wrapper'

export interface Props {
  directReferral: boolean
  dispatchReturnToOriginalStep: () => void
  onBack: () => void
  onContinue: () => void
  onEnter?: () => void
  stepByStepApplicationStep: ApplicationStep | undefined
  stepByStepApplicationStepIsValid: boolean
  currentStep: number
  totalNumberOfSteps: number
}

export const StepbystepApplicationStepAddress: React.SFC<Props> = (props) => (
  <StepbystepCreditApplicationWrapper {...props}>
    <StepTitle>Where do you live?</StepTitle>
    <ApplicationField
      product={Product.CreditCard}
      field={Fields.AddressOne}
      forceFocus={true}
      onEnter={props.onEnter}
    />
    <ApplicationField product={Product.CreditCard} field={Fields.AddressTwo} onEnter={props.onEnter} />
    <ApplicationField product={Product.CreditCard} field={Fields.Zipcode} onEnter={props.onEnter} />
    <ApplicationField product={Product.CreditCard} field={Fields.City} onEnter={props.onEnter} />
    <ApplicationField product={Product.CreditCard} field={Fields.State} onEnter={props.onEnter} />
  </StepbystepCreditApplicationWrapper>
)
